export const environment = {
    production: true,
    configFile: 'assets/config/config.json',
    EmployementAppURL: 'https://PnxEmploymentJob175.prophoenix.com'
};


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/environments/environment.ts